/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateRoundUpOnboardingFlow} from '../api'

export const useMutationInitiateRoundUpOnboardingFlow = createReactQueryMutationHook('initiateRoundUpOnboardingFlow', initiateRoundUpOnboardingFlow)
